import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { HiringGoalsContent } from '@/components/pages/channels/hiring-goals-modal/hiring-goals-content';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface HiringGoalModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hireATHiringGoalUrl: string;
}

function HiringGoalModal({
  open,
  onOpenChange,
  hireATHiringGoalUrl,
}: HiringGoalModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!fixed inset-y-0 right-0 !flex !h-full min-w-[550px] !flex-col">
        <DialogHeader className="flex-none pr-12">
          <DialogTitle>
            <FormattedMessage defaultMessage="Hiring goals" />
          </DialogTitle>
        </DialogHeader>
        <HiringGoalsContent
          hireATHiringGoalUrl={hireATHiringGoalUrl}
          onClose={() => onOpenChange(false)}
        />
        <DialogFooter />
      </DialogContent>
    </Dialog>
  );
}
export { HiringGoalModal };
